export const BOOTSTRAP_TAX_TYPES = 'BOOTSTRAP_TAX_TYPES'
export const ADD_TAX_TYPE = 'ADD_TAX_TYPE'
export const UPDATE_TAX_TYPE = 'UPDATE_TAX_TYPE'
export const DELETE_TAX_TYPE = 'DELETE_TAX_TYPE'
